// TODO: add react-helmet for document.title

export const Routes = {
    Home: "/",
    AdminKeywords: "/admin/keywords",
    AdminKeywordAdd: "/admin/keyword/new",
    AdminKeywordEdit: "/admin/keyword/edit",
    AdminInstantCharts: "/admin/instant-charts",
    AdminInstantChartAdd: "/admin/instant-chart/new",
    AdminInstantChartEdit: "/admin/instant-chart/edit",
    AdminSummaryReports: "/admin/summary-reports",
    AdminSummaryReportAdd: "/admin/summary-report/new",
    AdminSummaryReportEdit: "/admin/summary-report/edit",
    AdminCategoryReports: "/admin/category-reports",
    AdminCategoryReportAdd: "/admin/category-report/new",
    AdminCategoryReportEdit: "/admin/category-report/edit",
    menuExamples: "/menu-examples",
    reports: "/reports",
    instantCharts: "/instant-charts",
    foodProfile: "/food-profile",
    test: "/test",
    foodProfiles: "/food-profiles",
    topTrends: "/topTrends",
    byo: "/byo",
};

export const ADMIN_ROUTES = [
    Routes.AdminKeywords,
    Routes.AdminKeywordAdd,
    Routes.AdminKeywordEdit,
    Routes.AdminInstantCharts,
    Routes.AdminInstantChartAdd,
    Routes.AdminInstantChartEdit,
    Routes.AdminSummaryReports,
    Routes.AdminSummaryReportAdd,
    Routes.AdminSummaryReportEdit,
    Routes.AdminCategoryReports,
    Routes.AdminCategoryReportAdd,
    Routes.AdminCategoryReportEdit,
];
